'use client';
import { ListboxOptionTextContainer } from '../listbox/listbox-option-text-container.component.js';

/**
 * @subcomponent Combobox
 */ const ComboboxOptionTextContainer = ListboxOptionTextContainer;

export { ComboboxOptionTextContainer };
